import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { Transfer } from '../../models/transfer.model';
import { TransfersActions } from './transfers.actions';

export interface TransfersState extends EntityState<Transfer> {
  loading: boolean;
  error: string | null;
}

export const adapter = createEntityAdapter<Transfer>();
const initialState: TransfersState = adapter.getInitialState({ loading: false, error: null });

export const transfersFeature = createFeature({
  name: 'transfers',
  reducer: createReducer(
    initialState,
    on(TransfersActions.loadTransfers, (state) => ({ ...state, loading: true, error: null })),
    on(TransfersActions.loadTransfersSuccess, (state, { transfers }) =>
      adapter.setAll(transfers, { ...state, loading: false })),
    on(TransfersActions.loadTransfersFailure, (state, { error }) => ({ ...state, loading: false, error })),
    on(TransfersActions.createTransferSuccess, (state, { transfer }) => adapter.addOne(transfer, state)),
    on(TransfersActions.cashHandoffSuccess, (state, { transfer }) => adapter.addOne(transfer, state)),
  )
});

export const {
  name: transfersFeatureKey,
  reducer,
  selectTransfersState,
  selectLoading: selectTransfersLoading,
} = transfersFeature;

export const { selectAll } = adapter.getSelectors();
